import BusinessIdentifierApi from '@/api/masterData/businessIdentifiersApi'
export default {
  namespaced: true,
  state: {
    ids: {}
  },
  mutations: {
    setIds(state, data) {
      state.ids = data;
    }
  },
  actions: {
    async fetchIds({commit, dispatch}) {
      try {
        const response = await BusinessIdentifierApi.fetchAll();
        commit('setIds', response.data);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
